import gql from 'graphql-tag';

export const updateConsumer = gql`
  mutation updateConsumer($input: UpdateConsumerInput!){
    updateConsumer(input: $input){
      id
    }
  }
`;
